import React from 'react';
import Container from 'react-bootstrap/Container';
import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';

function ReportNavBar(props) {



  return (
    <Navbar expand="lg" >
      <Container>
        <Navbar.Brand >
          <img
            alt=""
            src="TickMark192.png"
            width="30"
            height="30"
            className="d-inline-block align-top"
          />{' '}
          Report
        </Navbar.Brand>
        
        {/*<Navbar.Toggle aria-controls="basic-navbar-nav" />*/}
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
        <Nav.Item>
        <Nav className="me-auto">
          <Nav.Link href="/">Organizer</Nav.Link>
          </Nav>
          </Nav.Item>
   
         
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}
export default ReportNavBar